export type OralModel = {
    id?: number | undefined,
    name: string,
    source: string,
    period: string,
    enabled: boolean,
    mechanism: string,
    description: string,
    min: string,
    max: string,
    classifications: string[],
    userClassifications?: string[],
    favorite?: boolean,
    annotation?: string,
    isSelected?: boolean,
    volume?: string,
    unity?: string,
    percentage?: string,
}

export const oralModelToDetails = (oral: OralModel) => {
    return {
        name: oral.name,
        mechanism: oral.mechanism,
        description: oral.description,
        period: oral.period,
        min: oral.min,
        max: oral.max,
        source: oral.source,
        id: oral.id,
        enabled: oral.enabled,
        unity: oral.unity,
        classifications: oral.classifications,
        userClassifications: oral.userClassifications,
        favorite: oral.favorite,
        annotation: oral.annotation,
    }
}